/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateComparisonNameRequest
 */
export interface UpdateComparisonNameRequest {
    /**
     * New display name for the comparison
     * @type {string}
     * @memberof UpdateComparisonNameRequest
     */
    name: string;
}

/**
 * Check if a given object implements the UpdateComparisonNameRequest interface.
 */
export function instanceOfUpdateComparisonNameRequest(value: object): value is UpdateComparisonNameRequest {
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function UpdateComparisonNameRequestFromJSON(json: any): UpdateComparisonNameRequest {
    return UpdateComparisonNameRequestFromJSONTyped(json, false);
}

export function UpdateComparisonNameRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateComparisonNameRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
    };
}

export function UpdateComparisonNameRequestToJSON(json: any): UpdateComparisonNameRequest {
    return UpdateComparisonNameRequestToJSONTyped(json, false);
}

export function UpdateComparisonNameRequestToJSONTyped(value?: UpdateComparisonNameRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
    };
}

